var React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';

var Columnlist = createClass({

  propTypes: {
    elements: PropTypes.array,
    columns: PropTypes.number
  },

  getDefaultProps() {
    return {
      columns: 2
    };
  },

  render() {
    var columnClass = 'column-list-' + this.props.columns;
    return (
      <ul className={columnClass + ' vf-clear-ul'}>
        {this.props.elements}
      </ul>
    );
  }
});

module.exports = Columnlist;
